export const pageQuery = `
  page(id: $id, idType: $type) {
    callToAction {
      label
      link
    }
    callToActionFooter {
      label
      link
      sidebar
    }
    content
    excerpt
    featuredImage {
      node {
        altText
        description
        mediaDetails {
          height
          width
        }
        sourceUrl
      }
    }
    featuredImageWidth
    imageSrcset
    mediaBanner {
      altText
      caption
      carouselItems {
        altText
        caption
        enableDescription
        enableLink
        enablePlayPause
        enableSound
        imageFile
        imageSrcset
        imageUrl
        itemType
        linksTo
        muxLongVideoId
        muxShortVideoId
        muxVideoMobileId
      }
      enabled
      enableDescription
      enableLink
      enablePlayPause
      enableSound
      imageFile
      imageSrcset
      imageUrl
      itemType
      linksTo
      mediaType
      muxLongVideoId
      muxShortVideoId
      muxVideoMobileId
    }
    pageNavigation {
      label
      url
    }
    pageOptionalSubtitle
    parent {
      node {
        uri
        ... on Page {
          title
        }
      }
    }
    parentExhibition {
      title
      uri
    }
    title
    uri
  }
`;
